import { TVehicle } from "types";

interface IGetKfzSteuer {
  vehicle: TVehicle;
}

export const getKfzSteuer = ({ vehicle }: IGetKfzSteuer): number | null => {
  let EZ = 2021;
  if (vehicle.fzart.name !== "Neuwagen") {
    if (!vehicle.erstzulassung) return null;
    const month = new Date(vehicle.erstzulassung).getMonth() + 1;
    const year = new Date(vehicle.erstzulassung).getFullYear();
    switch (true) {
      case year >= 2021:
        EZ = 2021;
        break;
      case year >= 2014:
        EZ = 2014;
        break;
      case year >= 2012:
        EZ = 2012;
        break;
      case year >= 2010 || (year === 2009 && month >= 7):
        EZ = 2009;
        break;
      default:
        EZ = 2008;
    }
  }

  const faktorKraftstoff = vehicle.kraftstoff.name === "Diesel" ? 9.5 : 2;
  const faktorHubraum = Math.ceil(vehicle.hubraum / 100);
  const aufschlagCO2 = getCO2Aufschlag(vehicle.wltp_co2_emissionen, EZ);
  const kfzSteuer = faktorKraftstoff * faktorHubraum + aufschlagCO2;
  return Math.floor(kfzSteuer);
};

export const getCO2Aufschlag = (
  emission: number,
  year: number = 2021
): number => {
  let result = 0;
  let Faktoren = CO2Faktoren_2021;
  switch (true) {
    case year >= 2021:
      Faktoren = CO2Faktoren_2021;
      break;
    case year >= 2014:
      Faktoren = CO2Faktoren_2014;
      break;
    case year >= 2012:
      Faktoren = CO2Faktoren_2012;
      break;
    case year >= 2009:
      Faktoren = CO2Faktoren_2009;
      break;
    default:
      Faktoren = CO2Faktoren_2009;
  }
  Array.from(Array(emission).keys()).map(
    (emission) => (result += getCO2Faktor(emission + 1, Faktoren) * 10)
  );
  return result / 10;
};

export const getCO2Faktor = (
  emission: number,
  CO2Faktoren: any[] = CO2Faktoren_2021
): number => {
  const CO2Faktor = CO2Faktoren.find(({ maximum }) => emission <= maximum);
  return CO2Faktor ? CO2Faktor.faktor : 4;
};

const CO2Faktoren_2021 = [
  { faktor: 0, minimum: 0, maximum: 0 },
  { faktor: 0, minimum: 1, maximum: 95 },
  { faktor: 2, minimum: 95, maximum: 115 },
  { faktor: 2.2, minimum: 115, maximum: 135 },
  { faktor: 2.5, minimum: 135, maximum: 155 },
  { faktor: 2.9, minimum: 155, maximum: 175 },
  { faktor: 3.4, minimum: 175, maximum: 195 },
  { faktor: 4, minimum: 195, maximum: 10000 },
];

const CO2Faktoren_2014 = [
  { faktor: 0, minimum: 0, maximum: 95 },
  { faktor: 2, minimum: 95, maximum: 10000 },
];

const CO2Faktoren_2012 = [
  { faktor: 0, minimum: 0, maximum: 110 },
  { faktor: 2, minimum: 110, maximum: 10000 },
];

const CO2Faktoren_2009 = [
  { faktor: 0, minimum: 0, maximum: 120 },
  { faktor: 2, minimum: 120, maximum: 10000 },
];
